export const degrees45 = Math.PI / 4;
export const degrees90 = Math.PI / 2;
export const degrees180 = Math.PI;
export const degrees270 = Math.PI * 1.5;
